<template>

<div :class="[cart ? '':'container-fluid']">

<div  v-if="type=='B'">
<div >


<UpdateCouponForm v-if="updateForm" @close="setCoupon" v-bind:item="coupon"></UpdateCouponForm>
<modal-spinner    v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>  
<deleteModalBox   v-if="deleteModalBox" v-bind:couponId="couponId"  @close="closeDeleteBox()" @delete="deleteCouponId()"></deleteModalBox>
<div class="card border-primary" >
  <div class="card-header bg-primary text-white">
    <h4><i style="color:#FFCC00" class="fas fa-coins mr-3"></i>
    LISTA PROMO COUPON </h4>
  </div>

  <div class="card-body text-primary">

  <div>
    <button type="button" @click="createCoupon()" class="btn btn-success btn-block mt-1 ">
    <i  class="fas fa-edit mr-2" aria-hidden="true"></i>
    NUOVO COUPON</button>
  </div>    

  

    <div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">              
    <table class="table table-hover  mb-0" id="table">
    <thead >
   
      <tr class="table-primary">
        <th>

        </th>
        <th>

        </th>
        <th>
         # 
        </th> 
        <th>
          SEDE
        </th>   
        <th>
          PERIODO EMISSIONE 
        </th>  
        <th>
         EMESSO PER UN TOTALE ACQUISTI UGUALE O MAGGIORE DI € 
        </th>  
        <th>
          TIPO COUPON
        </th>  
        <th>
          VALORE COUPON
        </th>  
        
        <th>
          PERIODO VALIDITA'  
        </th>    
        
        <th>
            VALIDO PER UN TOTALE ACQUISTI UGUALE O MAGGIORE DI €
        </th>
      <!--
        <th>
         ATTIVO
        </th>
        
        -->
        
        <th>COUPON EMESSI</th>
        <th>COUPON UTILIZZATI</th>
        <th></th>
      </tr>
      
    </thead>
    <tbody>
      
      <tr class="pointer"  v-for="(item, index) in filteredItems" :key="index">

        <td>
          <i @click="updateCoupon(item)" style="color:brown" class="fas fa-edit mr-2" aria-hidden="true"></i>
        </td>
        <td>
          <i v-if="item.total_coupon_customer==0" @click="setDeleteModalBox(item)" style="color:black" class="fas fa-trash-alt mr-2" aria-hidden="true"></i>
        </td>
        <td>
          {{ item.couponId }}
        </td>
        <td>
          {{ item.stores }}
        </td>
        
        <td>
          {{ item.data1}} {{ item.data2 }}
        </td>

        <td>
          {{fmt1(item.total1)}}
        </td>
        <td>
          {{item.typeId == 1 ? 'EURO' : 'SCONTO'}}
        </td>
        
        <td>
            <span v-if="item.typeId == 1">{{fmt1(item.total)}}</span>
            <span v-if="item.typeId == 2"> {{item.total}} %</span>
        </td>
        <td>
          {{ item.data3}} {{ item.data4 }}
        </td>
        

        <td>
          {{fmt1(item.total2)}}
        </td>
        <!--
        <td>

          <i v-if="item.active==1" style="color:green" class="fas fa-ban " aria-hidden="true"></i>
          <i v-if="item.active==0" style="color:green" class="fas fa-check" aria-hidden="true"></i>
            
         </td>
        
        -->
        
         <td>
            {{item.total_coupon_customer}}
         </td>
         <td>
            {{item.total_coupon_customer_used}}
         </td>


         <td>
          {{ item.used_at }}
         </td>
        
    
      </tr>
      
    </tbody>
  </table> 
 </div>





  <label for="cerca">
  <i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>  
  <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">     
  </div>

</div>
</div>
</div>

<div  v-else>

<div class="row_">  

<!--  <div class="col-md-3"></div>-->

<div class="col_">
 
  <PromoCouponForm v-bind:couponId="couponId" @update="setData()"></PromoCouponForm>
</div>

</div>
    
</div>




<!-- LIST -->


</div>
</template>

<script>
import api                from '@/api';
import { mapGetters }     from 'vuex';


import modalSpinner       from '@/components/common/ModalSpinner.vue'


import fmt                from '@/components/mixins/fmt.js'
import {setFmtDate1}      from '@/functions'
import PromoCouponForm    from './PromoCouponForm.vue';
import deleteModalBox     from './deleteBoxModal.vue'





//import UpdateCouponForm   from './UpdateCouponForm.vue'

export default {
  mixins:[fmt],
   props : ['cart'],
   components: {
     modalSpinner,PromoCouponForm,deleteModalBox
     /*couponForm,UpdateCouponForm,*/
   
  },
  
  data () {
    return {
    
    modalSpinner   : {spinner:false,show:false},
    alert          : false, 
    items          : [],
    filterKey      : '',
    type           : 'B',
    
    deskId         : 1,
    updateForm     : false,
    coupon         : {},
    couponId       : 0,
    deleteModalBox : false  
    

    }
  },
  computed: 
  {  
    ...mapGetters(['company','storeId','isAdmin']),
    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     

  },
  watch: 
  {
    
  },
      
  async mounted()
  {

    const deskId = JSON.parse(localStorage.getItem("deskId"))    
    if(deskId)
    {    
      this.deskId = Number(deskId)
    
    }

    //this.receiptText =  await this.getReceiptHeading(this.storeId,this.deskId)
    
    this.getData()
    

  },
  created()  
  {

   
    
    
  }, 
  methods: 
    {
      closeDeleteBox()
      {
        this.deleteModalBox = false
        //this.getData()
      },
      setDeleteModalBox(item)
      {
        
        this.couponId = item.couponId
        this.deleteModalBox = true
      },

      deleteCouponId()
      {
        this.deleteModalBox = false
        this.deleteCoupon()
      },
      setCoupon(data)
      {
        this.items.forEach(item=>{
          if(item.couponId == data.couponId)
          {
            item.reference = data.reference
            item.tel       = data.tel
            item.expire_at = setFmtDate1(data.expire_at)            
          }
        })
        this.updateForm = false

      },
      updateCoupon(item)
      {
        console.log(item)
        if(item.active==0)  
        {

          this.couponId = item.couponId
          this.type = 'C'
          //console.log('updateCoupon',this.coupon)
          //this.updateForm = true
        }  
        
      },
      closeUpdateForm()
      {
        this.updateForm = false
      },

      setData()
      {
        this.type = 'B'
        this.getData()
      },
      createCoupon()
      {
        this.couponId = 0
        this.type = 'C'
      },
  
      setModalSpinner(show)
      {
        
        this.modalSpinner.show = show
        
      },

      
      async getData() 
      {
        
        this.modalSpinner.show    = true
        this.modalSpinner.spinner = true
        this.modalSpinner.title   = 'Caricamento coupon in corso ...'
        
        const data  = {'companyId' : this.company.Id}
        const sp = {'sp'           : 'spCompanyPromoCouponList'}        
        const json = Object.assign(data, sp)        
        await api.post(json).then(res => {
          
          if(res.status==200)
            {   
                
                //this.type = 'B'
                this.items = res.data.recordsets[0] 
                this.$nextTick(() => {
                  this.modalSpinner.show = false 
                  })     
                
            }
           else if(res.status==500)
           {
              
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = res.data
              
                                    
           } 
           else
            {
                            
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = res
                 
            } 
          

          }).catch(err => {
              
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = err.message
              
              
          }).finally(() => {
          
        });


      },
      
      async deleteCoupon() 
      {
        
        this.modalSpinner.show    = true
        this.modalSpinner.spinner = true
        this.modalSpinner.title   = 'Eliminazione coupon in corso ...'
        
        const data  = {'couponId'  : this.couponId}
        const sp = {'sp'           : 'spDeletePromoCoupon'}        
        const json = Object.assign(data, sp)        
        await api.post(json).then(res => {
          
          if(res.status==200)
            {   
                
                
              this.modalSpinner.show = false 
              this.getData()       
                
            }
           else if(res.status==500)
           {
              
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = res.data
              
                                    
           } 
           else
            {
                            
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = res
                 
            } 
          

          }).catch(err => {
              
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = err.message
              
              
          }).finally(() => {
          
        });


      },
      


      
     


    
    

  
  

    },
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 600px;
overflow : auto;
}
.table-wrapper-scroll-y {
display  : block;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
a,th{
  font-family : 'Roboto Condensed';
  font-size   : 15px;
 
}

input[type='checkbox'] {
 
  cursor         : pointer;
 
}
.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
tr{
  cursor: pointer;
}
.pointer:hover
{
  _background-color   : blue;
  _color              : white;
  _cursor             : pointer;
}

.dropdown-menu a:hover
{
  background-color: blue;
  color:white;
}
.card-header
{
  height: 45px;
}
</style>